import Table from "../../../../components/table/Table";
import { SpreadPriceHeaderName } from "../../../../components/tableHeaderNames/HeaderName";
import { useSpreadPriceContext } from "../../../../context/market-watch/SpreadPriceContext";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import SpreadPriceForm from "./SpreadPriceForm";

const SpreadPriceAdvance = () => {
  const { tableData } = useSpreadPriceContext();
  return (
    <Grid2 container spacing={1}>
      <Grid2 xs={12}>
        <Table
          tableData={tableData}
          Form={SpreadPriceForm}
          tableTitle={{
            title: "اسپرد قیمتی آپشن",
            desc: "متن آزمایشی",
          }}
          faCols={SpreadPriceHeaderName}
          isActions={true}
          height="80vh"
        />
      </Grid2>
    </Grid2>
  );
};

export default SpreadPriceAdvance;
